import React, {PropTypes} from "react";
import {connect} from "react-redux";
import NewJoinerTable from "./NewJoinerTable";
import axios from "axios";
import {RadioButton, RadioButtonGroup} from "material-ui";
import LoadingSpinner from "../../loadingSpinner";


function convert(node) {
  node.offerDate = node.offerDate ? new Date(node.offerDate) : null;
  node.joiningDate = node.joiningDate ? new Date(node.joiningDate) : null;
  return node;
}


class OnBoarding extends React.Component {

  constructor() {
    super();
    this.state = {joiners: [], loading:true}
    this.refresh = this.refresh.bind(this);
  }


  refresh() {
    axios.get(process.env.REQ_URL + "/onBoarding/getPastJoinersForOtherDepartments", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      response = response.data.data.map((node)=> {
        return convert(node);
      });
      let pastJoiners = response.filter((node)=> {
        let date = new Date();
        return node.joiningDate < date;
      });
      let todaysJoiners = response.filter((node)=> {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        return (date.getMonth() == node.joiningDate.getMonth() && date.getDay() == node.joiningDate.getDay() && date.getYear() == node.joiningDate.getYear())
      });

      this.setState({joiners: response, allJoiners: response, todaysJoiners: todaysJoiners, pastJoiners: pastJoiners, loading: false});
    }).catch((error)=> {

    })

  }

  componentDidMount() {
    this.props.changeBanner("OnBoarding")
    axios.get(process.env.REQ_URL + "/onBoarding/getPastJoinersForOtherDepartments", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      response = response.data.data.map((node)=> {
        return convert(node);
      });
      let pastJoiners = response.filter((node)=> {
        let date = new Date();
        return node.joiningDate < date;
      });
      let todaysJoiners = response.filter((node)=> {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        return (date.getDate() == node.joiningDate.getDate() && date.getDay() == node.joiningDate.getDay() && date.getYear() == node.joiningDate.getYear())
      });

      this.setState({joiners: response, allJoiners: response, todaysJoiners: todaysJoiners, pastJoiners: pastJoiners, loading:false});
    }).catch((error)=> {

    })

  }

  render() {
    return (
      <div>

        <div className="col-md-12">
          <div className="col-md-12">
            <RadioButtonGroup
              onChange={(event, value)=> {
                switch (value) {
                  case '1':
                    this.setState({joiners: this.state.allJoiners})
                    break;
                  case '2':
                    this.setState({joiners: this.state.todaysJoiners});
                    break;
                  case  '3':
                    this.setState({joiners: this.state.expectedJoiners});
                    break;
                  case '4':
                    this.setState({joiners: this.state.pastJoiners});
                    break;
                  default:
                    return;
                }

              }}
              name="shipSpeed" style={{display: 'flex'}} defaultSelected="1">
              <RadioButton
                style={{width: '25%'}}
                value="1"
                label="All"
              />
              <RadioButton
                style={{width: '25%'}}
                value="2"
                label="Today's Joinees"
              />

              <RadioButton
                style={{width: '25%'}}
                value="4"
                label="Past Joinees"
              />
            </RadioButtonGroup>
          </div>
        </div>
        <div className="col-md-12" style={{marginTop: '-20'}}>
          <hr/>
            { this.state.loading ? <LoadingSpinner/> : <NewJoinerTable
            refresh={this.refresh}
            constants={this.props.constants}
            data={this.state.joiners}/> }
        </div>
      </div>
    );
  }

}

OnBoarding.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state
  };

}


export default connect(mapStateToProps)(OnBoarding);




/** WEBPACK FOOTER **
 ** ./src/feature/it/OnBoarding/OnBoarding.js
 **/